import { render, staticRenderFns } from "./PageDetails.vue?vue&type=template&id=29a16fbb&scoped=true"
import script from "./PageDetails.vue?vue&type=script&lang=js"
export * from "./PageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a16fbb",
  null
  
)

export default component.exports